import { style, styleVariants } from '@vanilla-extract/css';

const baseAdvantages = style({
  display: 'flex',
  gap: '2.6rem',
  flexWrap: 'wrap',
});

export const css = {
  heading: style({
    display: 'flex',
    justifyContent: 'space-between',
  }),
  advantages: styleVariants({
    small: [baseAdvantages, { marginTop: '0.7rem' }],
    regular: [baseAdvantages, { marginTop: '2rem' }],
  }),
  advantage: style({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4rem',
    lineHeight: '2.2rem',
    '::before': {
      position: 'absolute',
      top: '50%',
      width: '1.2rem',
      height: '0.6rem',
      background: 'var(--gradient-red)',
      borderTopLeftRadius: '0.7rem',
      borderTopRightRadius: '0.7rem',
      transform: 'translateY(-50%)',
      content: "''",
    },
  }),
  advantageSpan: style({
    marginLeft: '2.2rem',
  }),
  rightHeader: style({
    display: 'flex',
    alignItems: 'center',
  }),
};
